var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":'/assets/icons_' + _vm.$store.state.iconTheme + '/' + _vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }